import React from 'react';
import useSessionEntity from '../hooks/useSessionEntity';
import Support from './shared/Support';

export default function Error() {
  const merchant = useSessionEntity('merchant');

  return (
    <div id="content" className="has-text-centered mt-2">
      <p>You have reached this page in error.</p>
      {merchant && <a href={merchant.url}>Click here to return to {merchant.name}</a>}
      {!merchant && <a href="https://www.creditkey.com">Click here to return to Credit Key</a>}

      <Support />
    </div>
  )
}
